var __jsx = React.createElement;
import React from "react";
import { useDhamenContext } from "@/common/Contexts/DhamenContextProvider";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useTranslation } from "@i18n";
import { twMerge } from "tailwind-merge";
import { MIN_FINANCING_AMOUNT } from "@/pages/checkout/dhamen/constants";
import { Icon } from "@syarahtech/ui";
import SAR from "@componentsShared/SAR/SAR";
import InfoModal from "@/pages/checkout/dhamen/components/common/InfoModal";
import useBoolean from "@hooks/useBoolean";
import WarrningLimit from "@/pages/checkout/dhamen/icons/WarrningLimit";
function OrderData() {
  var _useDhamenContext = useDhamenContext(),
    state = _useDhamenContext.state;
  var _ref = state.orderInfo || {},
    order = _ref.order;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var limitModal = useBoolean();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "rounded-xl border  border-solid  border-[#EBF0F7] self-stretch px-2 py-2 inline-flex flex-col justify-start items-center w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "self-stretch py-2 inline-flex justify-between items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-right justify-start text-Color-Neutral-50 text-xs font-medium leading-4"
  }, tShort("dhamen/request_financing_on")), /*#__PURE__*/React.createElement("div", {
    className: "text-right justify-start text-Color-Neutral-90 text-sm font-bold leading-5"
  }, lang == "ar" ? order.post_details.title_ar : order.post_details.title_en)), /*#__PURE__*/React.createElement("div", {
    className: "self-stretch h-16 py-2 inline-flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inline-flex flex-col justify-start items-start gap-0.5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inline-flex justify-center items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-right justify-start text-slate-500 text-xs font-medium leading-4"
  }, tShort("dhamen/car_price"))), /*#__PURE__*/React.createElement("div", {
    className: "self-stretch inline-flex  items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-right justify-start text-neutral-700 text-base font-bold leading-5"
  }, order.pricing.total_price, " SAR"))), /*#__PURE__*/React.createElement("div", {
    className: "inline-flex flex-col justify-start items-start gap-0.5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inline-flex justify-center items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-right justify-start text-slate-500 text-xs font-medium leading-4"
  }, tShort("dhamen/down_payment"))), /*#__PURE__*/React.createElement("div", {
    className: "self-stretch inline-flex items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-right justify-start text-neutral-700 text-base font-bold leading-5"
  }, order.pricing.arboon, " SAR"))), /*#__PURE__*/React.createElement("div", {
    className: "inline-flex flex-col justify-start items-start gap-0.5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inline-flex justify-center items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-right justify-start text-slate-500 text-xs font-medium leading-4"
  }, tShort("dhamen/total_financing_amount"))), /*#__PURE__*/React.createElement("div", {
    className: "self-stretch inline-flex  items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("text-right justify-start  text-base font-bold leading-5", state.financingAmount >= MIN_FINANCING_AMOUNT ? "text-[#00B362]" : "text-[#F22C2C]")
  }, state.financingAmount.toLocaleString(), " SAR")))), state.isExceedLimit && /*#__PURE__*/React.createElement("div", {
    className: "bg-[#FDEFEB] w-full py-2 px-2 text-xs rounded-sm flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-2 flex items-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--warning-rounded",
    className: "text-[#EC6234]",
    width: 5,
    height: 5
  }), /*#__PURE__*/React.createElement("span", {
    className: "px-1"
  }, tShort("dhamen/max_limit")), /*#__PURE__*/React.createElement("span", {
    className: "font-bold"
  }, state.exceedLimitType === "saudi" ? "100,000" : "50,000"), /*#__PURE__*/React.createElement(SAR, {
    className: "text-sm  px-1"
  })), /*#__PURE__*/React.createElement("div", {
    className: "font-bold px-1 text-[#004da8] underline cursor-pointer",
    onClick: limitModal.setTrue
  }, tShort("dhamen/more")))), /*#__PURE__*/React.createElement(InfoModal, {
    icon: /*#__PURE__*/React.createElement(WarrningLimit, null),
    secondaryButton: {
      label: tShort("dhamen/close"),
      onClick: limitModal.setFalse
    },
    text: tShort("dhamen/max_limit_text"),
    onClose: limitModal.setFalse,
    open: limitModal.value,
    toggle: limitModal.toggle,
    title: "".concat(tShort("dhamen/max_limit2"), " ").concat(state.exceedLimitType === "saudi" ? "100,000 SAR" : "50,000 SAR")
  }));
}
export default OrderData;